import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../../../shared/api";
import {
  CloseRaplRequestBody,
  GetRaplRequestsParams,
  RaplRequestResponse,
  RaplRequestsResponse,
  UpdateRaplRequestBody,
} from "./types";

export const raplRequestsApi = createApi({
  reducerPath: "raplRequestsApi",
  baseQuery: baseApiQuery,
  tagTypes: ["RaplRequests"],
  endpoints: (builder) => ({
    getRaplRequests: builder.query<RaplRequestsResponse, GetRaplRequestsParams>(
      {
        query: (params) => {
          const qp = new URLSearchParams();
          if (params.search) qp.append("search", params.search);
          if (params.status) qp.append("status", params.status);
          if (params.sort) qp.append("sort", params.sort);
          if (params.order) qp.append("order", params.order);
          if (params.pageToken) qp.append("pageToken", params.pageToken);
          if (params.limit != null)
            qp.append("limit", params.limit.toString());
          return `/admin/raplrequests${qp.toString() ? `?${qp.toString()}` : ""}`;
        },
        providesTags: ["RaplRequests"],
      },
    ),

    updateRaplRequest: builder.mutation<
      RaplRequestResponse,
      { id: number; body: UpdateRaplRequestBody }
    >({
      query: ({ id, body }) => ({
        url: `/admin/raplrequests/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["RaplRequests"],
    }),

    hideRaplRequest: builder.mutation<RaplRequestResponse, number>({
      query: (id) => ({
        url: `/admin/raplrequests/${id}/hide`,
        method: "POST",
      }),
      invalidatesTags: ["RaplRequests"],
    }),

    showRaplRequest: builder.mutation<RaplRequestResponse, number>({
      query: (id) => ({
        url: `/admin/raplrequests/${id}/show`,
        method: "POST",
      }),
      invalidatesTags: ["RaplRequests"],
    }),

    closeRaplRequest: builder.mutation<
      RaplRequestResponse,
      { id: number; body: CloseRaplRequestBody }
    >({
      query: ({ id, body }) => ({
        url: `/admin/raplrequests/${id}/close`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["RaplRequests"],
    }),
  }),
});

export const {
  useGetRaplRequestsQuery,
  useUpdateRaplRequestMutation,
  useHideRaplRequestMutation,
  useShowRaplRequestMutation,
  useCloseRaplRequestMutation,
} = raplRequestsApi;
